import { createAsyncThunk } from '@reduxjs/toolkit'

import { PerformerController } from 'controller/performer/controller'
import { IPerformerData } from 'meta/pages/v4/performer'

type Returned = IPerformerData[]

type Props = {
  codes: string[]
}

export const getBulkData = createAsyncThunk<Returned, Props>('pages/performer/bulk', async (props) => {
  const { codes } = props

  const data = await PerformerController.getBulkData({ codes })

  return data.items
})
